import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Roster } from "@app/models/rest/roster/roster";

@Injectable({
  providedIn: "root"
})
export class RosterRestService extends HateoasResourceOperation<Roster> {
  constructor() {
    super(Roster);
  }
}
